import type { AssociationFileDTO } from '@/features/api/extranet/dto/shared/AssociationFileDTO'
import type { NatureConfigDTO } from '@/features/api/extranet/dto/shared/NatureConfigDTO'
import { ensureSuccessStatusCode, useFetch } from '@/features/fetch'
import type { Endpoint } from '@/features/interface/detail/components/UploadFiles.types'

const INIT_DEFAULT: RequestInit = { sablier: true, dialogMode: 'retry' } as const

export async function loadNaturesForFile(endpoint: Endpoint, init?: RequestInit): Promise<NatureConfigDTO[]> {
  if (!init) init = { sablier: true, dialogMode: 'retry' }

  const fetch = useFetch('extranet')
  const response = await fetch(`/${endpoint}/documents/natures`, init)
  ensureSuccessStatusCode(response)
  const result = await response.json()

  return result.data as NatureConfigDTO[]
}

function download(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}

export async function downloadDocument(endpoint: Endpoint, code: string, id: number, name: string, init?: RequestInit) {
  init = { ...{ sablier: true, dialogMode: 'retry' }, ...(init ?? {}) }

  const fetch = useFetch('extranet')
  const response = await fetch(`/${endpoint}/${code}/download/${id}`, init)
  ensureSuccessStatusCode(response)
  response.blob().then((blob) => download(blob, name))
}

type AssociateDocumentOptions = {
  endpoint: Endpoint
  code: string
  documents: AssociationFileDTO[]
}
export async function associateDocument(options: AssociateDocumentOptions, init?: RequestInit) {
  if (!init) init = INIT_DEFAULT

  const request: RequestInit = {
    ...INIT_DEFAULT,
    ...init,
    method: 'POST',
    body: JSON.stringify(options.documents),
  }

  const fetch = useFetch('extranet')
  const response = await fetch(`/${options.endpoint}/${options.code}/upload`, request)
  ensureSuccessStatusCode(response)

  return response
}
